module.exports = __webpack_public_path__ + "img/teamwork.93ac7cfe.png";